const listView = (docCookies) => {
    const viewItems = document.querySelectorAll("[data-select-view]");
    const viewContainer = document.querySelector("[data-view]");

    for (var i = 0; i < viewItems.length; i++) {
        viewItems[i].addEventListener("click", function(e){
            if (viewContainer) {
                viewContainer.dataset.view = this.dataset.selectView;
                for (var i = 0; i < viewItems.length; i++) {
                    viewItems[i].classList.remove("active");
                }
                this.classList.add("active");
                docCookies.setCookie("listView", this.dataset.selectView, 30, "/");
            }
        })
    }

    const cookie = docCookies.showCookie("listView");
    if (cookie && viewContainer) {
        viewContainer.dataset.view = cookie;
        for (var i = 0; i < viewItems.length; i++) {
            viewItems[i].classList.remove("active");
        }
        const active = document.querySelector("[data-select-view='" + cookie + "']");
        active.classList.add("active");
    }
}

export default listView;
